module.exports = __webpack_public_path__ + "img/037.fa60705a.jpg";